export default __webpack_public_path__ + "img/ehihBpBP.e1ce7f23.svg";